// extracted by mini-css-extract-plugin
export default {"main":"DashboardLayout_main__79o7z","bento":"DashboardLayout_bento__D-GK4","tabContent":"DashboardLayout_tabContent__4YBQb"};